import React from 'react';
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { makeStyles, IconButton, Button, Box } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu'; 
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import MenuAndroid from '../AppAndroid';
import Notificacion from '../Notificacion';
const drawerWidth = 240;

const useStyles =makeStyles(theme=>({    
    menuButton: {
        marginRight: theme.spacing(2),
       /*  [theme.breakpoints.up('lg')]: {
            display: 'none',
          }, */
      },
    mititulo:{
        //flexGrow:1
        textAlign:'center',
        //paddingTop:"1rem"
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            //width: `calc(100% - ${drawerWidth}px)`,
            width: `calc(100%)`,
            marginLeft: drawerWidth,
          },
      },
      appBarSinloguear: {
        
            width: `100% `,
            //marginLeft: drawerWidth,          
      },
}))

const Navbar = (propiedades) => {
    const {guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);
    let history = useHistory();
    //let auxTitulo1='Pruebas - '+generales.Titulo
    //let auxTitulo2='Pruebas - Mexicable'
    let auxTitulo1=generales.Titulo    
    let auxTitulo2='Linea Verde'
    const misclases=useStyles()
    const CerrarSesion = e=>{
        e.preventDefault();
        localStorage.clear();
        guardarGenerales([])       	
        guardarUsuario([])
        history.push("/")			
    }
    return (
    
        <AppBar className={propiedades.usuario.length!==0?misclases.appBar:misclases.appBarSinloguear}
         position="fixed" color="primary">
            <Toolbar>
              {  propiedades.usuario.length !== 0  ?
                <IconButton color="inherit"  aria-label="menu" className={misclases.menuButton} 
                    onClick={()=>propiedades.funcionAbrir()}  size='small'>
                    <MenuIcon/>
                </IconButton>
            :null }
            <Box  flexGrow={1} >
            <Typography variant="h6" className={misclases.mititulo}>
                {generales.length!==0 ? auxTitulo1 : auxTitulo2}
            </Typography>
           
            </Box>
             <Typography variant="h6" style={{marginRight:"1rem"}}>
                PRUEBAS
            </Typography>
            <Notificacion usuario={propiedades.usuario} />
            <MenuAndroid/>
            
            {propiedades.usuario.length!==0?<Button variant="text" color="inherit" onClick={CerrarSesion}>
                Cerrar Sesion
            </Button>:null}
            {/* */}
            </Toolbar>
        </AppBar>
        
    );
}
 
export default Navbar;